import { render, staticRenderFns } from "./AssignmentAddEditModal.vue?vue&type=template&id=a831d4a4&"
import script from "./AssignmentAddEditModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports